import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

interface GetProfileIdQueryResponse {
  yozmitProfileId: number;
  yozmitOnboardingStatus: number;
  isAlarmedCollectionActivity: boolean;
  authorProfileId: number;
  authorProfileUrlIdentifier: string;
}

export const useGetProfileIdQuery = (enabled: boolean) => {
  return useQuery({
    queryKey: ['getProfileIdApi'],
    queryFn: async () => {
      const { data } =
        await clientAxios.get<ApiResponse<GetProfileIdQueryResponse>>(
          '/getProfileIdApi/'
        );

      return {
        yozmitProfileId: data.data.yozmitProfileId,
        yozmitOnboardingStatus: data.data.yozmitOnboardingStatus,
        hasNewCollection: data.data.isAlarmedCollectionActivity,
        authorProfileId: data.data.authorProfileId,
        authorProfileUrlIdentifier: data.data.authorProfileUrlIdentifier,
      };
    },
    enabled,
  });
};

interface PatchProfileMutateParams {
  image: File | '';
  yozmitProfileId: number;
}

export const usePatchProfileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      image,
      yozmitProfileId,
    }: PatchProfileMutateParams) => {
      const formData = new FormData();
      formData.append('yozmitProfileId', yozmitProfileId.toString());
      if (image) formData.append('image', image);

      return clientAxios.patch('/patchProfileApi/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getProfileApi'] });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const usePatchCollectionAlarmOffMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => clientAxios.patch('/patchCollectionAlarmOffApi/'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getProfileIdApi'] });
    },
  });
};
